import { array, boolean, defineAction, object, string } from '~/prix'
import systemPropagateToOlapAction from './systemPropagateToOlap.action.json' with { type: 'json' }

const systemPropagateToOlapDefinition = defineAction({
  ...systemPropagateToOlapAction,
  input: object({
    useCustomTableList: boolean(),
    tablesAndSchemas: array(string()),
    propagationLevel: string(),
  }),
  output: object({}),
})
export default systemPropagateToOlapDefinition
